import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var downloadAppIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.5 19.5h-5V18H8v1.5c0 .83.67 1.5 1.5 1.5h5c.85 0 1.5-.69 1.5-1.55V18h-1.5v1.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17 0H7C5.34 0 4 1.35 4 3v18c0 1.66 1.35 3 3 3h9.99c1.66 0 3-1.35 3-3V3c0-1.66-1.35-3-3-3zm1.5 21c0 .83-.67 1.5-1.5 1.5H7c-.83 0-1.5-.67-1.5-1.5V3c0-.83.67-1.5 1.5-1.5h2.62v.11c0 .63.51 1.14 1.14 1.14h2.23c.63 0 1.14-.51 1.14-1.14V1.5h2.86c.83 0 1.5.67 1.5 1.5v18z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m15.21 13.04-2.4 2.34V8.33h-.5c-.55 0-1 .45-1 1v6.16l-2.7-2.63a.754.754 0 0 0-1.06.01l-.52.54 4.4 4.29a.767.767 0 0 0 1.2-.04l4.36-4.26-.35-.36c-.39-.4-1.02-.4-1.42-.02zm-2.46-7.21V4.26h-.5c-.55 0-1 .45-1 1v1.57h.5c.55 0 1-.45 1-1z"
}));

export { downloadAppIcon as default };
//# sourceMappingURL=downloadAppIcon.js.map
